import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { Input, Card, ReactSelector } from "../../../../../_metronic/_partials/controls";
import IconClose from "../../../../../assets/img/icon-close.svg";
import DeleteIcon from "../../../../../assets/img/company/Vector.svg";

import * as taxesActions from "../../../../../_redux/taxes/taxesActions";
import { i18n } from "../../../private/languageSelector";
import SubscriptionDialog from "../SubscriptionDialog";
import TaxSelectionModal from "./TaxSelectionModal";
import { handleDataPermissions } from "../../../../../helpers/helpers";

export const AddTaxSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, i18n("Validation.Minimun3Alphabets"))
    .max(50, i18n("Validation.Maximum50Alphabets"))
    .required(i18n("Validation.EnglishNameIsRequired")),
  // taxRate: Yup.number()
  //   .typeError(i18n("Validation.PleaseEnterNumber"))
  //   .required(i18n("Validation.TaxRateIsRequired")),
  taxRate: Yup.string()
    .required(i18n("Validation.TaxRateIsRequired"))
    .matches(/^\d+(\.\d+)?$/, "Please enter numbers only")
    .test("is-in-range", "Tax rate should not exceed 100", (value) => {
      const number = parseFloat(value);
      return !isNaN(number) && number >= 0 && number <= 100;
    }),
});

const initAddState = {
  name: "",
  taxRate: "",
  type: { value: "Included in the price", label: i18n("global.IncludedInPrice") },
};

const defaultType = [
  { value: "Included in the price", label: i18n("global.IncludedInPrice") },
  { value: "Added to the price", label: i18n("global.AddedToPrice") },
];

export function TaxesEditForm({ tax, edit, openTaxesAddDialog, setOpenTaxesAddDialog, setShowDeleteTaxModal, products }) {
  const dispatch = useDispatch();
  let productIds = products?.map((item) => item?._id);
  const [isFormFilled, setIsFormFilled] = useState(false);
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);
  const [showTaxSelectionModal, setShowTaxSelectionModal] = useState(false);
  const [unselectedProdCount, setUnselectedProdCount] = useState(0);
  const [defaultProductLoading, setDefaultProductLoading] = useState(false);
  const [productsToAddInTaxes, setProductsToAddInTaxes] = useState(productIds);

  const handleClosePaymentDialog = (dirty, resetForm) => {
    if (dirty) {
      setShowUnsavedChangesModal(true);
    } else {
      setOpenTaxesAddDialog(false);
      resetForm();
    }
  };

  useEffect(() => {
    if (openTaxesAddDialog) {
      setProductsToAddInTaxes(undefined);
    }
    //eslint-disable-next-line
  }, [openTaxesAddDialog]);

  const { language, user } = useSelector((state) => ({ language: state.auth?.language, user: state.auth?.user }));
  useEffect(() => {
    if (defaultProductLoading) {
      setProductsToAddInTaxes(tax?.products);
    }
      //eslint-disable-next-line
  }, [defaultProductLoading]);
  return (
    <Formik
      enableReinitialize={true}
      initialValues={
        edit
          ? {
              ...tax,
              type: {
                value: tax?.type,
                label: tax?.type?.includes("Added")
                  ? i18n("global.AddedToPrice")
                  : tax?.type?.includes("Included")
                  ? i18n("global.IncludedInPrice")
                  : tax?.type,
              },
              taxScheme: { value: tax?.taxScheme, label: tax?.taxScheme },
            }
          : initAddState
      }
      validationSchema={AddTaxSchema}
      onSubmit={(values, { resetForm }) => {
        if (edit) {
          dispatch(
            taxesActions.updateTax(tax?._id, {
              name: values.name,
              taxRate: values.taxRate,
              type: values.type?.value,
              taxScheme: values.taxScheme?.label,
              products: productsToAddInTaxes === undefined ? productIds : productsToAddInTaxes,
            }),
          );
        } else {
          dispatch(
            taxesActions.createTax({
              name: values.name,
              taxRate: values.taxRate,
              type: values.type?.value ? values.type?.value : values.type,
              taxScheme: values.taxScheme?.label ? values.taxScheme?.label : values.taxScheme,
              products: productsToAddInTaxes === undefined ? productIds : productsToAddInTaxes,
            }),
          );
        }
        resetForm();
        setOpenTaxesAddDialog(false);
        setDefaultProductLoading(false);
        setProductsToAddInTaxes(productIds);
      }}
    >
      {({ handleSubmit, values, setFieldValue, dirty, resetForm }) => {
        if (values.name && values.taxRate && values.type.value) {
          setIsFormFilled(true);
        }

        return (
          <>
            <Modal
              className={`${language === "arabic" ? "modal-dialog-arabic modal-drawer" : " modal-drawer"}  my-profile invoice-drawer`}
              size="lg"
              aria-labelledby="example-modal-sizes-title-lg"
              show={openTaxesAddDialog}
              onHide={() => handleClosePaymentDialog(dirty, resetForm)}
            >
              <Modal.Header>
                <div className={`d-flex justify-content-between align-items-center ${language === "arabic" ? "rtl" : "ltr"}`}>
                  <span onClick={() => handleClosePaymentDialog(dirty, resetForm)} className="cursor-pointer">
                    <img src={IconClose} alt="closeIcon" />
                  </span>
                  <span>
                    {edit === false ? (
                      <span className="add-edit-tax">{i18n("global.AddTax")}</span>
                    ) : (
                      <span className="add-edit-tax">{i18n("global.EditTax")}</span>
                    )}
                  </span>
                  <span
                    onClick={handleSubmit}
                    className="add-edit-tax cursor-pointer"
                    style={{
                      color: isFormFilled && "#FFFFFF",
                      opacity: isFormFilled ? 1 : 0.5,
                    }}
                  >
                    {i18n("UserProfile.Save")}
                  </span>
                </div>
              </Modal.Header>
              <Modal.Body className={`overlay overlay-block cursor-default ${language === "arabic" ? "rtl" : "ltr"}`}>
                <Form className="form form-label-right">
                  <Card>
                    <div className="invoice-title border-bottom-0">
                      <p className="m-0">{i18n("global.TaxInformation")}</p>
                    </div>
                    <div className="invoice-items row">
                      <div className="col-12">
                        <div className="form-group">
                          <Field name="name" component={Input} placeholder={i18n("global.TaxName")} label={i18n("global.TaxName")} />
                        </div>
                        <div className="form-group">
                          <Field name="taxRate" component={Input} placeholder={i18n("global.TaxRate")} label={i18n("global.TaxRate")} />
                        </div>
                      </div>
                    </div>
                  </Card>
                  <Card>
                    <div className="invoice-title border-bottom-0">
                      <p className="m-0">{i18n("global.DefaultTaxScheme")}</p>
                    </div>
                    <div className="invoice-items row">
                      <div className="col-12">
                        <div className="form-group input-select w-100">
                          <Field
                            name="type"
                            placeholder={i18n("global.Type")}
                            component={ReactSelector}
                            options={defaultType.map((item) => ({
                              value: item.value,
                              label: item.label,
                            }))}
                            onChange={(option) => {
                              setFieldValue("type", option);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </Card>
                  <Card>
                    <div className="invoice-title flex-column border-bottom-0 mb-0">
                      <p className="m-0 mb-4">{i18n("global.ApplyToProducts")}</p>
                      <div className="tax-muted-description w-100">{i18n("global.ApplyCustomTaxDescription")}</div>
                    </div>
                    <div className="invoice-items row">
                      <div className="col-12">
                        <div className="form-group input-select w-100" onClick={() => setShowTaxSelectionModal(true)}>
                          <div style={{ pointerEvents: "none" }}>
                            <Field
                              name="selectProduct"
                              placeholder={
                                unselectedProdCount > 0 ? `${unselectedProdCount} ${i18n("global.ProductDeselected")}` : i18n("global.SelectProducts")
                              }
                              component={ReactSelector}
                              onClick={() => {
                                setShowTaxSelectionModal(true);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>

                  {edit && handleDataPermissions(user)?.deleteData ? (
                    <Card>
                      <div className="w-100">
                        <div className="text-center">
                          <img
                            src={DeleteIcon}
                            alt="delete"
                            width={18}
                            height={20}
                            className="cursor-pointer"
                            onClick={() => setShowDeleteTaxModal(true)}
                          />
                        </div>
                      </div>
                    </Card>
                  ) : null}

                  {/* un-saved changes modal */}
                  <SubscriptionDialog
                    modalWidth={"350px"}
                    modalHeight={"185px"}
                    modalBackgroundColor={"#FFFFFF"}
                    show={showUnsavedChangesModal}
                    onHide={() => setShowUnsavedChangesModal(false)}
                    title={i18n("SubscriptionModals.UnsavedChanges")}
                    titleWidth={"140px"}
                    titleHeight={"20px"}
                    titleFontWeight={"700"}
                    titleFontSize={"16px"}
                    titleLineHeight={"20px"}
                    titleColor={"#333333"}
                    message={i18n("SubscriptionModals.AreYouSureYouWantToContinueWithoutSavingChanges")}
                    messageWidth={"320px"}
                    messageHeight={"44px"}
                    messageFontSize={"16px"}
                    messageFontWeight={"400"}
                    messageLineHeight={"21.79px"}
                    messageColor={"#333333"}
                    primaryLabel={i18n("SubscriptionModals.CANCEL")}
                    primaryAction={() => setShowUnsavedChangesModal(false)}
                    primaryLabelWidth={"55px"}
                    primaryLabelHeight={"20px"}
                    primaryLabelFontWeight={"700"}
                    primaryLabelFontSize={"14px"}
                    primaryLabelLineHeight={"20px"}
                    primaryLabelColor={"#828282"}
                    secondaryAction={() => {
                      setShowUnsavedChangesModal(false);
                      setOpenTaxesAddDialog(false);
                      setIsFormFilled(false);
                      resetForm();
                    }}
                    secondaryLabel={i18n("SubscriptionModals.CONTINUE")}
                    secondaryLabelWidth={"75px"}
                    secondaryLabelHeight={"20px"}
                    secondaryLabelFontWeight={"700"}
                    secondaryLabelFontSize={"14px"}
                    secondaryLabelLineHeight={"20px"}
                    secondaryLabelColor={"#2D9CDB"}
                    isCenteredOnMobile
                  />
                  <TaxSelectionModal
                    show={showTaxSelectionModal}
                    language={language}
                    isFormFilled={"true"}
                    tax={tax}
                    taxValues={values}
                    setOpenTaxesAddDialog={setOpenTaxesAddDialog}
                    setUnselectedProdCount={setUnselectedProdCount}
                    setProductIds={setProductsToAddInTaxes}
                    setDefaultProductLoading={setDefaultProductLoading}
                    setShowTaxSelectionModal={setShowTaxSelectionModal}
                    openTaxesAddDialog={openTaxesAddDialog}
                  />
                </Form>
              </Modal.Body>
            </Modal>
          </>
        );
      }}
    </Formik>
  );
}
